<template>
  <v-card>
    <v-card-title>
      Addresses
      <v-spacer></v-spacer>
      <v-btn outlined @click="$refs.addressForm.doOpen({})">
        <v-icon>mdi-plus</v-icon>Add Addresses
      </v-btn>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="addresses"
      :loading="loading"
      :options.sync="options"
    >
      <template #[`item.typeId`]="{item}">
        <v-chip outlined small class="mr-2">{{ item.typeId }}</v-chip>
      </template>
      <template #[`item.default`]="{item}">
        <v-chip color="warning" outlined small v-if="item.default">default</v-chip>
      </template>
            <template #[`item.country`]="{item}">
        {{ getCountryName(item.country) }}
      </template>
      <template v-slot:item.actions="{item}">
        <v-btn small outlined class="mr-2" color="warning" @click="doMarkAsDefault(item)" :disabled="!!item.default">Mark as default</v-btn>
        <v-btn small outlined class="mr-2" @click="$refs.addressForm.doOpen(item)">Edit</v-btn>
        <v-btn small outlined color="error" @click="deleteItem(item)">Delete</v-btn>
      </template>
    </v-data-table>
    <addresse-form
      ref="addressForm"
      :clientId="this.customer.id"
      @updated="refresh()"
    ></addresse-form>
  </v-card>
</template>

<script>
import { getCountryName } from "@/utils/country.js";
import AddresseForm from "./CustomerAddressForm.vue";
export default {
  components: {
    AddresseForm
  },
  props: {
    customer: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: null,
      options: null,
      totalCount: null,
      addresses: this.customer.clientAddresses,
      headers: [
        { text: "Type", value: "typeId", align: "center" },
        { text: "Default", value: "default", align: "center" },
        { text: "Company", value: "company", align: "left" },
        { text: "Address", value: "address" },
        { text: "City", value: "city" },
        { text: "State", value: "state" },
        { text: "Postal Code", value: "postalCode" },
        { text: "Country", value: "country" },
        { text: "Actions", value: "actions", sortable: false }
      ],
      formAddress: false,
      addresseToEdit: null
    };
  },
  mounted () {
    this.getAddresses();
  },
  methods: {
    getCountryName,
    getAddresses() {
      this.$store
        .dispatch("clientAddresses/get", {
          id: this.customer.id
        })
        .then(({ addresses }) => (this.addresses = addresses));
    },
    refresh() {
      this.getAddresses();
    },
    editItem(item) {
      this.addresseToEdit = Object.assign({}, item);
      this.formAddress = true;
    },
    deleteItem(item) {
      confirm("Are you sure you want to delete this item?") &&
        this.$store
          .dispatch("clientAddresses/delete", {
            model: item
          })
          .then(({ addresses }) => (this.addresses = addresses));
    },
    doMarkAsDefault(item) {
      this.$store.dispatch("clientAddresses/markAsDefault", item)
      .then(({ addresses }) => (this.addresses = addresses));
    }
  }
};
</script>
